import React from "react";
import { createRoot } from "react-dom/client";
import "./app.css";
import { App } from "./App";
import { installBootGuard } from "./bootGuard";
import { installBrowserLogCapture } from "./debug/browserLogs";
import { installAppVersionMonitor } from "./services/appVersionMonitor";

installBootGuard();
installBrowserLogCapture();
installAppVersionMonitor();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
